import { jsx as t, jsxs as a } from "react/jsx-runtime";
import { forwardRef as l, Suspense as c, cloneElement as p } from "react";
import { Typography as b } from "../Typography/index.js";
import { c as g } from "../../index-2a9bde35.js";
const f = g({
  base: "tw-inline-flex tw-w-auto tw-flex tw-max-h-8 tw-p-2 tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-md tw-text-sm tw-font-semibold tw-ring-offset-background tw-transition-color focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50",
  variants: {
    variant: {
      white: "tw-bg-white-5 tw-text-black-4",
      blue: "tw-bg-blue-1 tw-text-blue-7",
      green: "tw-bg-green-1 tw-text-green-7",
      red: "tw-bg-red-1 tw-text-red-7",
      purple: "tw-bg-purple-1 tw-text-purple-7",
      pink: "tw-bg-pink-1 tw-text-pink-7",
      orange: "tw-bg-orange-1 tw-text-orange-7"
    },
    iconPlacement: {
      left: "tw-flex-row",
      right: "tw-flex-row-reverse"
    }
  }
}), m = l(
  ({
    className: r,
    variant: n = "blue",
    text: i,
    iconPlacement: o = "left",
    icon: e,
    ...w
  }, s) => /* @__PURE__ */ t(c, { fallback: /* @__PURE__ */ t("div", { children: "..." }), children: /* @__PURE__ */ a(
    "button",
    {
      className: f({ variant: n, iconPlacement: o, className: r }),
      ref: s,
      ...w,
      children: [
        e && p(e, { className: "" }),
        /* @__PURE__ */ t(b, { variant: "b3_14medium", className: "tw-h-auto", children: i })
      ]
    }
  ) })
);
m.displayName = "Tags";
export {
  m as Tags,
  f as tagVariants
};
